export default "{\n    \"essentialsLabel\": \"ResQ Essentials\",\n    \"suspended\": \"Suspended\"\n}\n"